"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var portal_core_1 = require("@ferry/portal-core");
var InfoModal = /** @class */ (function (_super) {
    __extends(InfoModal, _super);
    function InfoModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    InfoModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggle });
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "cursor-pointer ".concat(this.props.className, " info-button ml-2"), onClick: this.toggle, tabIndex: 0, "aria-label": "".concat(this.props.title), onKeyPress: this.toggle, role: "button" }), (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal ".concat(this.props.modalClassName), isOpen: this.state.isOpen, toggle: this.toggle, children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn, children: [(0, jsx_runtime_1.jsxs)("div", { className: "info-popup-title", children: [(0, jsx_runtime_1.jsx)("img", { src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/info-popup.svg"), alt: "Attention" }), (0, jsx_runtime_1.jsx)("div", { className: "font-weight-bold", children: this.props.title })] }), this.props.header] }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: this.props.children }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex flex-column", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary width-md-250 mb-1 ".concat(this.props.showArrow ? "" : "btn-next-no-arrow"), onClick: this.toggle, children: "Ok, I understand" }) })] })] }));
    };
    InfoModal.prototype.toggle = function () {
        this.setState(function (state) { return ({
            isOpen: !state.isOpen
        }); });
    };
    return InfoModal;
}(React.Component));
exports.InfoModal = InfoModal;
//# sourceMappingURL=InfoModal.js.map